import * as React from 'react';
import { Navigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AuthService from '../services/auth.js';
import "../Amenities.css"

import CustomSnackbar from '../components/CustomSnackbar';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
// Simple time picker components
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import Drawer from '@mui/material/Drawer';

import apiClient, { shouldRedirectToLogin, getErrorMessage } from '../services/api-client';
import AppConfig from '../services/app-config';

// Import new icons
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import BlockIcon from '@mui/icons-material/Block';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseIcon from '@mui/icons-material/Close';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

// Add this import at the top with other MUI imports
import Alert from '@mui/material/Alert';
import WarningIcon from '@mui/icons-material/Warning';

export default function Home({setNavbarState, navbarState, window}) {
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' });
  const [loading, setLoading] = React.useState(true);
  const [amenity, setAmenity] = React.useState({});
  const [amenityReservations,setAmenityReservations] = React.useState({});
  const [drawerShow, setDrawerShow] = React.useState(false);
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const [date,setDate] = React.useState(dayjs());
  const [timeRanges, setTimeRanges] = React.useState({});
  const [initialTimeValues, setInitialTimeValues] = React.useState({ from: null, to: null });
  const [selectionMode, setSelectionMode] = React.useState('free');
  const [timeSelectionError, setTimeSelectionError] = React.useState('');
  const [timelineFullscreen, setTimelineFullscreen] = React.useState(false);
  const [timelineSelectionStep, setTimelineSelectionStep] = React.useState('start');
  const [reservationDialog,setReservationDialog] = React.useState(false);
  const [adminReservationDialog,setAdminReservationDialog] = React.useState({show: false, resident_name: "", resident_unit: "", error: false, error_msg: ""});
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [refresh,setRefresh] = React.useState(false);
  const [monthReservations, setMonthReservations] = React.useState({});

  const autoAdjustedDateRef = React.useRef(null);
  const [reservationsLoadedKey, setReservationsLoadedKey] = React.useState('');

  const [adminOptionsDrawerOpen, setAdminOptionsDrawerOpen] = React.useState(false);
  const [blockModalOpen, setBlockModalOpen] = React.useState(false);
  const [blockData, setBlockData] = React.useState({
    motivo: "",
    fecha_inicio: new Date().toISOString().slice(0, 16),
    fecha_fin: new Date(new Date().getTime() + 2 * 60 * 60 * 1000).toISOString().slice(0, 16)
  });

  const amenityId = new URLSearchParams(location.search).get('id');
  const apiUrl = process.env.REACT_APP_MGO_API_URL;

  const weekDays = ["Lunes","Martes","Miercoles","Jueves","Viernes","Sabado","Domingo"]
  const monthsSpa = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octobre","Noviembre","Diciembre"]

    var regex = null
  if (AppConfig.getLocal("unit_regex")) {
    regex = new RegExp(AppConfig.getLocal("unit_regex"));
  }

  var unit_sample = ""
  if (AppConfig.getLocal("unit_sample")) {
    unit_sample = AppConfig.getLocal("unit_sample");
  }

  const timeToString = (time) => {
    if (time < 60) {
      return `${time} minutos`;
    } else {
      const hours = Math.floor(time / 60);
      const minutes = time % 60;
      if (minutes === 0) {
        return `${hours} horas`;
      } else {
        return `${hours} horas y ${minutes} minutos`;
      }
    }
  };

  const closeReservationDialog = () => {
    setReservationDialog(false);
  }

  const closeAdminReservationDialog = () => {
    setAdminReservationDialog({...adminReservationDialog, show: false});
  }

  const triggerRefresh = () => {
    setRefresh(!refresh);
  }

  const handleAdminReservation = () => {
    setAdminReservationDialog({ ...adminReservationDialog, show: true });
  }

  const handleUnitChange = (e) => {
    var unit_valid = {error: false, error_msg: ""}
    if (AppConfig.getLocal("unit_regex")) {
      var text = e.target.value;
      if (AppConfig.getLocal("unit_sample")) {
        var complement_length = AppConfig.getLocal("unit_sample").length - text.length ;
        var complement_text = AppConfig.getLocal("unit_sample").slice(-complement_length);
        if (complement_length === 0) {
          complement_text = "" ;
        }
        text = `${text}${complement_text}`
      }
      if (!regex.test(text)) {
        unit_valid = {error: true, error_msg: `Formato Incorrecto ej. ${AppConfig.getLocal("unit_sample")}`}
      }
    } 
    setAdminReservationDialog({ ...adminReservationDialog, ...unit_valid, resident_unit: e.target.value });
  }

  const makeReservation = () => {
    setLoading(true);
    setShowBackdrop(true);
    setReservationDialog(false);
    console.log({amenidad: amenityId, inicio: timeRanges.from.value.unix(), fin: timeRanges.to.value.unix(), residente: adminReservationDialog.resident_name, unidad: adminReservationDialog.resident_unit})
    apiClient.post('reservation/create', {amenidad: amenityId, inicio: timeRanges.from.value.unix(), fin: timeRanges.to.value.unix(), residente: adminReservationDialog.resident_name, unidad: adminReservationDialog.resident_unit}, {}, { action: 'create_reservation' })
      .then(response => {
        if (response.status === 200) {
          let default_msg = 'Reservacion creada correctamente'
          if (response.data.data.mensaje) {
            default_msg = response.data.data.mensaje;
          }
          // setSnackbar({ open: true, message: default_msg, severity: 'success' });
          // setReservationDialog(false);
          // fetchInfo(date,amenityId);
          setRedirect({ trigger: true, route: `/reservacion?id=${response.data.data.id}&msg=${default_msg}&lvl=success` });
        } else if (response.status === 422) {
          setSnackbar({ open: true, message: response.data.data.mensaje, severity: 'error' });
        }
        setLoading(false);
        setShowBackdrop(false);
      })
      .catch(error => {
        if(error.response && error.response.data && error.response.data.code === 422) {
          setSnackbar({ open: true, message: error.response.data.data.mensaje, severity: 'error' });
        }
        else  {
        console.error('Error fetching reservations:', error);
        setSnackbar({ open: true, message: "Hubo un error al intentar completar la reservacion porfavor intenta de nuevo mas tarde.", severity: 'error' })};
        setLoading(false);
        setShowBackdrop(false);
      });
  }

  const makeReservationPre = () => {
    if (!amenity.amenidad_nocturna && hasNoValidTimeOptions) {
      setSnackbar({ open: true, message: "No hay horarios disponibles para completar la reserva con la selección actual", severity: 'error' });
      return;
    }
    if (AuthService.getCurrentUserRole() === "admin") {
      if (adminReservationDialog.resident_name === "" || adminReservationDialog.resident_unit === "") {
        setSnackbar({ open: true, message: "Porfavor ingresar todos los datos del residente", severity: 'error' });
        return;
      }
      if (AppConfig.getLocal("unit_regex")) {
        if (!regex.test(adminReservationDialog.resident_unit)) {
          setSnackbar({ open: true, message: `Formato de apartamento incorrecto ej. ${unit_sample}`, severity: 'error' });
          return;
        }
      }
    }
    if (!amenity.amenidad_nocturna && timeRanges.to.value.isBefore(timeRanges.from.value)) {
      setSnackbar({ open: true, message: "La hora de finalizacion debe de ser mayor a la de inicio", severity: 'error' });
      return;
    }
    if (amenity.amenidad_nocturna && timeRanges.to.value.isAfter(timeRanges.from.value) && !timeRanges.to.value.isSame(timeRanges.from.value, 'day')) {
      setSnackbar({ open: true, message: "Para reservaciones nocturnas, la hora de finalización debe ser menor a la de inicio o en el mismo día", severity: 'error' });
      return;
    }
    if (timeRanges.to.value.isBefore(dayjs())) {
      setSnackbar({ open: true, message: "Los rangos de tiempo de la reserva ya pasaron ", severity: 'error' });
      return;
    }
    if (timeRanges.to.value.isSame(timeRanges.from.value)) {
      setSnackbar({ open: true, message: "La hora de inicio y final son las mismas", severity: 'error' });
      return;
    }
    closeAdminReservationDialog()
    setReservationDialog(true);
  }


  const handleDrawerToggle = () => {
    const nextDrawerState = !drawerShow;
    setDrawerShow(nextDrawerState);

    if (
      nextDrawerState &&
      !amenity.amenidad_nocturna &&
      initialTimeValues.from &&
      initialTimeValues.to &&
      timeRanges.from &&
      timeRanges.to
    ) {
      setSelectionMode('free');
      setTimeSelectionError('');
      setTimelineSelectionStep('start');
      setTimelineFullscreen(false);
      setTimeRanges(prev => ({
        ...prev,
        from: { ...prev.from, value: initialTimeValues.from },
        to: { ...prev.to, value: initialTimeValues.to }
      }));
    }
  }

  const handleDateChange = (newDate) => {
    setDate(newDate);
  };
  
  const handleMonthChange = (newMonth) => {
    // Fetch reservations for the new month to update the dots
    fetchMonthlyReservations(newMonth, amenityId);
  };

  // Generate array of time options in 15 minute increments
  const generateTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const hourStr = hour.toString().padStart(2, '0');
        const minuteStr = minute.toString().padStart(2, '0');
        const timeStr = `${hourStr}:${minuteStr}`;
        options.push(timeStr);
      }
    }
    return options;
  };

  const timeOptions = generateTimeOptions();

  const parseTimeOptionForDate = (timeStr) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return date.set('hour', hours).set('minute', minutes).set('second', 0);
  };

  const amenityReservationsList = Array.isArray(amenityReservations) ? amenityReservations : [];

  const hasOverlapWithReservations = (startUnix, endUnix) => {
    const overlapWithReservation = amenityReservationsList.some((reservation) => {
      const reservationStart = Number(reservation.inicio);
      const reservationEnd = Number(reservation.fin);
      if (!Number.isFinite(reservationStart) || !Number.isFinite(reservationEnd)) {
        return false;
      }
      // Half-open interval overlap: [start, end) vs [reservationStart, reservationEnd)
      return startUnix < reservationEnd && endUnix > reservationStart;
    });

    if (overlapWithReservation) {
      return true;
    }

    if (amenity.bloquear && amenity.bloquear.fecha_inicio && amenity.bloquear.fecha_fin) {
      const blockStart = Number(amenity.bloquear.fecha_inicio);
      const blockEnd = Number(amenity.bloquear.fecha_fin);
      if (Number.isFinite(blockStart) && Number.isFinite(blockEnd)) {
        return startUnix < blockEnd && endUnix > blockStart;
      }
    }

    return false;
  };

  const isTimeValid = (startTime, endTime) => {
    if (!startTime || !endTime || !amenity.reservacion || !amenity.horario_hoy) {
      return false;
    }

    if (!endTime.isAfter(startTime)) {
      return false;
    }

    const openingTime = amenity.horario_hoy.inicio;
    const closingTime = amenity.horario_hoy.fin;
    if (!openingTime || !closingTime) {
      return false;
    }

    if (startTime.isBefore(openingTime) || endTime.isAfter(closingTime)) {
      return false;
    }

    const reservationDuration = endTime.diff(startTime, 'minute');
    const minDuration = amenity.reservacion.tiempo_minimo;
    const maxDuration = amenity.reservacion.tiempo_maximo;
    if (reservationDuration < minDuration || reservationDuration > maxDuration) {
      return false;
    }

    return !hasOverlapWithReservations(startTime.unix(), endTime.unix());
  };

  const isStartTimeAvailable = (startTime) => {
    if (!startTime || !amenity.reservacion || !amenity.horario_hoy) {
      return false;
    }

    const minDuration = amenity.reservacion.tiempo_minimo;
    const openingTime = amenity.horario_hoy.inicio;
    const closingTime = amenity.horario_hoy.fin;
    const latestStart = dayjs(closingTime).subtract(minDuration, 'minute');

    if (startTime.isBefore(openingTime) || startTime.isAfter(latestStart)) {
      return false;
    }

    // Prevent choosing start times inside blocked/reserved windows.
    return !hasOverlapWithReservations(startTime.unix(), dayjs(startTime).add(15, 'minute').unix());
  };

  const startTimeOptions = React.useMemo(() => {
    if (!timeRanges.from || !timeRanges.to) {
      return [];
    }

    if (amenity.amenidad_nocturna) {
      return timeOptions.filter((time) => {
        const timeValue = parseTimeOptionForDate(time);
        const isDisabled =
          (timeRanges.from.min && timeValue.isBefore(timeRanges.from.min)) ||
          (timeRanges.from.max && timeValue.isAfter(timeRanges.from.max));
        return !isDisabled;
      });
    }

    if (!amenity.reservacion || !amenity.horario_hoy) {
      return [];
    }

    const minDuration = amenity.reservacion.tiempo_minimo;
    const openingTime = amenity.horario_hoy.inicio;
    const closingTime = amenity.horario_hoy.fin;
    const latestStartByMinDuration = dayjs(closingTime).subtract(minDuration, 'minute');

    return timeOptions.filter((time) => {
      const candidateStart = parseTimeOptionForDate(time);
      if (candidateStart.isBefore(openingTime) || candidateStart.isAfter(latestStartByMinDuration)) {
        return false;
      }

      return isStartTimeAvailable(candidateStart);
    });
  }, [amenity.amenidad_nocturna, amenity.horario_hoy, amenity.reservacion, date, timeOptions, timeRanges.from, timeRanges.to, amenityReservationsList, amenity.bloquear]);

  const endTimeOptions = React.useMemo(() => {
    if (!timeRanges.from || !timeRanges.to) {
      return [];
    }

    if (amenity.amenidad_nocturna) {
      return timeOptions.filter((time) => {
        const timeValue = parseTimeOptionForDate(time);
        if (timeRanges.from.value && timeValue.isSameOrBefore(timeRanges.from.value)) {
          return false;
        }
        return true;
      });
    }

    if (!amenity.reservacion || !amenity.horario_hoy || !timeRanges.from.value) {
      return [];
    }

    const minDuration = amenity.reservacion.tiempo_minimo;
    const minEndByDuration = dayjs(timeRanges.from.value).add(minDuration, 'minute');
    const closingTime = amenity.horario_hoy.fin;

    return timeOptions.filter((time) => {
      const candidateEnd = parseTimeOptionForDate(time);
      if (candidateEnd.isBefore(minEndByDuration) || candidateEnd.isAfter(closingTime)) {
        return false;
      }

      return isTimeValid(timeRanges.from.value, candidateEnd);
    });
  }, [amenity.amenidad_nocturna, amenity.horario_hoy, amenity.reservacion, date, timeOptions, timeRanges.from, timeRanges.to, amenityReservationsList, amenity.bloquear]);

  const hasNoValidTimeOptions =
    !amenity.amenidad_nocturna &&
    !!timeRanges.from?.value &&
    endTimeOptions.length === 0;

  const selectedStartValue = timeRanges.from?.value ? timeRanges.from.value.format('HH:mm') : '';
  const selectedEndValue = timeRanges.to?.value ? timeRanges.to.value.format('HH:mm') : '';
  const safeStartValue = selectedStartValue;
  const safeEndValue = selectedEndValue;

  const startOptionsForSelect = React.useMemo(() => {
    if (!selectedStartValue || startTimeOptions.includes(selectedStartValue)) {
      return startTimeOptions;
    }
    return [selectedStartValue, ...startTimeOptions];
  }, [selectedStartValue, startTimeOptions]);

  const endOptionsForSelect = React.useMemo(() => {
    if (!selectedEndValue || endTimeOptions.includes(selectedEndValue)) {
      return endTimeOptions;
    }
    return [selectedEndValue, ...endTimeOptions];
  }, [selectedEndValue, endTimeOptions]);

  React.useEffect(() => {
    if (amenity.amenidad_nocturna || selectionMode !== 'constrained') {
      setTimeSelectionError('');
      return;
    }

    if (endTimeOptions.length === 0) {
      setTimeSelectionError('No hay horas de finalización disponibles para la hora de inicio seleccionada.');
      return;
    }

    setTimeSelectionError('');
  }, [amenity.amenidad_nocturna, endTimeOptions.length, selectionMode]);

  React.useEffect(() => {
    if (
      amenity.amenidad_nocturna ||
      !timeRanges.from ||
      !timeRanges.to ||
      !timeRanges.from.value ||
      !timeRanges.to.value ||
      !initialTimeValues.from ||
      !initialTimeValues.to
    ) {
      return;
    }

    const returnedToInitialState =
      timeRanges.from.value.isSame(initialTimeValues.from, 'minute') &&
      timeRanges.to.value.isSame(initialTimeValues.to, 'minute');

    if (returnedToInitialState && selectionMode !== 'free') {
      setSelectionMode('free');
      setTimeSelectionError('');
      setTimelineSelectionStep('start');
    }
  }, [amenity.amenidad_nocturna, initialTimeValues.from, initialTimeValues.to, selectionMode, timeRanges.from, timeRanges.to]);

  React.useEffect(() => {
    if (
      amenity.amenidad_nocturna ||
      !timeRanges.to ||
      !timeRanges.to.value
    ) {
      return;
    }

    const selectedEnd = timeRanges.to.value.format('HH:mm');
    if (!endTimeOptions.includes(selectedEnd) && endTimeOptions.length > 0) {
      setTimeRanges(prev => ({
        ...prev,
        to: {
          ...prev.to,
          value: parseTimeOptionForDate(endTimeOptions[0])
        }
      }));
    }
  }, [amenity.amenidad_nocturna, endTimeOptions, selectionMode, timeRanges.to]);

  React.useEffect(() => {
    if (timelineSelectionStep !== 'end') {
      return;
    }

    const selectedStart = timeRanges.from?.value ? timeRanges.from.value.format('HH:mm') : '';
    if (!selectedStart || !startTimeOptions.includes(selectedStart)) {
      setTimelineSelectionStep('start');
    }
  }, [startTimeOptions, timeRanges.from, timelineSelectionStep]);

  React.useEffect(() => {
    if (
      amenity.amenidad_nocturna ||
      amenity.horario_predefinido ||
      !amenity.disponible_hoy ||
      !amenity.reservacion ||
      !amenity.horario_hoy ||
      !amenity.horario_hoy.inicio ||
      !amenity.horario_hoy.fin ||
      !timeRanges.from?.value ||
      !timeRanges.to?.value ||
      !initialTimeValues.from ||
      !initialTimeValues.to
    ) {
      return;
    }

    const expectedReservationsKey = date.format('DDMMYY');
    if (reservationsLoadedKey !== expectedReservationsKey) {
      return;
    }

    const dateKey = date.format('YYYY-MM-DD');
    if (autoAdjustedDateRef.current === dateKey) {
      return;
    }

    const userHasModifiedDefaults =
      !timeRanges.from.value.isSame(initialTimeValues.from, 'minute') ||
      !timeRanges.to.value.isSame(initialTimeValues.to, 'minute');

    if (userHasModifiedDefaults) {
      autoAdjustedDateRef.current = dateKey;
      return;
    }

    const desiredDurationMinutes = initialTimeValues.to.diff(initialTimeValues.from, 'minute');
    const minDuration = amenity.reservacion.tiempo_minimo;
    const clampedDesiredDuration = Math.max(minDuration, desiredDurationMinutes);
    const openingTime = dayjs(amenity.horario_hoy.inicio);
    const closingTime = dayjs(amenity.horario_hoy.fin);

    const currentRangeValid = isTimeValid(timeRanges.from.value, timeRanges.to.value);
    if (currentRangeValid) {
      autoAdjustedDateRef.current = dateKey;
      return;
    }

    let nextFrom = null;
    let nextTo = null;
    const latestStart = dayjs(closingTime).subtract(minDuration, 'minute');
    let pointer = dayjs(openingTime);

    while (pointer.isSameOrBefore(latestStart)) {
      if (isStartTimeAvailable(pointer)) {
        const preferredEnd = dayjs(pointer).add(clampedDesiredDuration, 'minute');
        const candidateEnds = timeOptions
          .map((time) => parseTimeOptionForDate(time))
          .filter((end) => end.isAfter(pointer))
          .filter((end) => isTimeValid(pointer, end));

        if (candidateEnds.length > 0) {
          const preferredMatch = candidateEnds.find((end) => end.isSame(preferredEnd, 'minute'));
          nextFrom = pointer;
          nextTo = preferredMatch || candidateEnds[0];
          break;
        }
      }

      pointer = pointer.add(15, 'minute');
    }

    if (!nextFrom || !nextTo) {
      autoAdjustedDateRef.current = dateKey;
      return;
    }

    autoAdjustedDateRef.current = dateKey;
    setSelectionMode('free');
    setTimeSelectionError('');
    setTimelineSelectionStep('start');
    setTimelineFullscreen(false);
    setInitialTimeValues({ from: nextFrom, to: nextTo });
    setTimeRanges((prev) => ({
      ...prev,
      from: { ...prev.from, value: nextFrom },
      to: { ...prev.to, value: nextTo }
    }));
  }, [
    amenity.amenidad_nocturna,
    amenity.bloquear,
    amenity.disponible_hoy,
    amenity.horario_hoy,
    amenity.horario_predefinido,
    amenity.reservacion,
    amenityReservationsList,
    date,
    initialTimeValues.from,
    initialTimeValues.to,
    reservationsLoadedKey,
    timeOptions,
    timeRanges.from,
    timeRanges.to
  ]);

  const handleTimeStartChange = (event) => {
    const newTimeStr = event.target.value;
    const newTime = parseTimeOptionForDate(newTimeStr);

    if (amenity.amenidad_nocturna) {
      let timeRangesTemp = { ...timeRanges, from: { ...timeRanges.from, value: newTime } };

      if (amenity.reservacion && amenity.reservacion.tiempo_minimo) {
        const minEndTime = dayjs(newTime).add(amenity.reservacion.tiempo_minimo, 'minutes');
        timeRangesTemp = {
          ...timeRangesTemp,
          to: {
            ...timeRangesTemp.to,
            min: minEndTime,
            value: timeRangesTemp.to.value && timeRangesTemp.to.value.isBefore(minEndTime)
              ? dayjs(newTime).add(amenity.reservacion.tiempo_minimo, 'minutes')
              : timeRangesTemp.to.value
          }
        };
      }

      setTimeRanges(timeRangesTemp);
      return;
    }

    const isReturningToInitial =
      initialTimeValues.from &&
      initialTimeValues.to &&
      newTime.isSame(initialTimeValues.from, 'minute') &&
      timeRanges.to.value &&
      timeRanges.to.value.isSame(initialTimeValues.to, 'minute');

    if (isReturningToInitial) {
      setSelectionMode('free');
      setTimelineSelectionStep('start');
    } else {
      setSelectionMode('constrained');
      setTimelineSelectionStep('end');
    }

    setTimeRanges(prev => ({
      ...prev,
      from: { ...prev.from, value: newTime }
    }));
  };

  const handleTimeEndChange = (event) => {
    const newTimeStr = event.target.value;
    const newTime = parseTimeOptionForDate(newTimeStr);

    if (!amenity.amenidad_nocturna) {
      const isReturningToInitial =
        initialTimeValues.from &&
        initialTimeValues.to &&
        timeRanges.from.value &&
        timeRanges.from.value.isSame(initialTimeValues.from, 'minute') &&
        newTime.isSame(initialTimeValues.to, 'minute');

      if (isReturningToInitial) {
        setSelectionMode('free');
        setTimelineSelectionStep('start');
      } else {
        setSelectionMode('constrained');
        setTimelineSelectionStep('start');
      }
    }

    setTimeRanges(prev => ({
      ...prev,
      to: { ...prev.to, value: newTime }
    }));
  };

  const timelineRows = React.useMemo(() => {
    if (!amenity.horario_hoy || !amenity.horario_hoy.inicio || !amenity.horario_hoy.fin) {
      return [];
    }

    const rows = [];
    let pointer = dayjs(amenity.horario_hoy.inicio);
    const closingTime = dayjs(amenity.horario_hoy.fin);

    while (pointer.isBefore(closingTime)) {
      const slotStart = dayjs(pointer);
      const potentialEnd = slotStart.add(15, 'minute');
      const slotEnd = potentialEnd.isAfter(closingTime) ? closingTime : potentialEnd;
      const overlappingReservation = amenityReservationsList.find((reservation) => {
        const reservationStart = Number(reservation.inicio);
        const reservationEnd = Number(reservation.fin);
        if (!Number.isFinite(reservationStart) || !Number.isFinite(reservationEnd)) {
          return false;
        }
        return slotStart.unix() < reservationEnd && slotEnd.unix() > reservationStart;
      });

      const hasBlockOverlap = amenity.bloquear && amenity.bloquear.fecha_inicio && amenity.bloquear.fecha_fin
        ? slotStart.unix() < Number(amenity.bloquear.fecha_fin) && slotEnd.unix() > Number(amenity.bloquear.fecha_inicio)
        : false;

      let slotLabel = 'Disponible';
      let slotType = 'available';
      if (hasBlockOverlap) {
        slotLabel = 'Bloqueado';
        slotType = 'blocked';
      } else if (overlappingReservation) {
        if (overlappingReservation.servicio) {
          slotLabel = 'Mantenimiento';
          slotType = 'maintenance';
        } else if (overlappingReservation.usuario === AuthService.getCurrentUserEmail()) {
          slotLabel = overlappingReservation.confirmada ? 'Tu reserva' : 'Tu reserva pendiente';
          slotType = 'mine';
        } else {
          slotLabel = 'Reservado';
          slotType = 'reserved';
        }
      }

      const slotTime = slotStart.format('HH:mm');
      rows.push({
        key: slotStart.unix(),
        slotStart,
        slotEnd,
        slotTime,
        slotLabel,
        slotType
      });

      pointer = slotStart.add(15, 'minute');
    }

    rows.push({
      key: `closing-${closingTime.unix()}`,
      slotStart: closingTime,
      slotEnd: closingTime,
      slotTime: closingTime.format('HH:mm'),
      slotLabel: 'Cierre',
      slotType: 'closing'
    });

    return rows;
  }, [amenity.bloquear, amenity.horario_hoy, amenityReservationsList]);

  const timelineHourGroups = React.useMemo(() => {
    const groups = [];
    let currentHourKey = null;
    let currentGroup = null;

    timelineRows
      .filter((row) => row.slotType !== 'closing')
      .forEach((row) => {
        const hourKey = row.slotStart.format('HH');
        if (hourKey !== currentHourKey) {
          currentHourKey = hourKey;
          currentGroup = { hourKey, hourLabel: `${hourKey}:00`, slots: [] };
          groups.push(currentGroup);
        }
        currentGroup.slots.push(row);
      });

    const closingRow = timelineRows.find((row) => row.slotType === 'closing');
    return { groups, closingRow };
  }, [timelineRows]);

  const startOptionsSet = React.useMemo(() => new Set(startTimeOptions), [startTimeOptions]);
  const endOptionsSet = React.useMemo(() => new Set(endTimeOptions), [endTimeOptions]);

  const handleTimelineSlotClick = (slotTime) => {
    if (amenity.amenidad_nocturna || amenity.horario_predefinido || !slotTime) {
      return;
    }

    const nextTime = parseTimeOptionForDate(slotTime);
    const canUseAsStart = startOptionsSet.has(slotTime);
    const canUseAsEnd = endOptionsSet.has(slotTime);

    if (timelineSelectionStep === 'start') {
      if (!canUseAsStart) {
        return;
      }

      const isReturningToInitial =
        initialTimeValues.from &&
        initialTimeValues.to &&
        nextTime.isSame(initialTimeValues.from, 'minute') &&
        timeRanges.to?.value &&
        timeRanges.to.value.isSame(initialTimeValues.to, 'minute');

      setSelectionMode(isReturningToInitial ? 'free' : 'constrained');
      setTimelineSelectionStep('end');
      setTimeRanges(prev => ({
        ...prev,
        from: { ...prev.from, value: nextTime }
      }));
      return;
    }

    if (canUseAsEnd) {
      setSelectionMode('constrained');
      setTimelineSelectionStep('start');
      setTimeRanges(prev => ({
        ...prev,
        to: { ...prev.to, value: nextTime }
      }));
      return;
    }

    if (canUseAsStart) {
      setSelectionMode('constrained');
      setTimelineSelectionStep('end');
      setTimeRanges(prev => ({
        ...prev,
        from: { ...prev.from, value: nextTime }
      }));
    }
  };

  const renderAvailabilityGrid = (isFullscreen = false) => {
    const selectedStart = timeRanges.from?.value ? timeRanges.from.value.format('HH:mm') : '';
    const selectedEnd = timeRanges.to?.value ? timeRanges.to.value.format('HH:mm') : '';
    const canSelectGraphically = !amenity.amenidad_nocturna && !amenity.horario_predefinido;

    const segmentHeight = isFullscreen ? 18 : 14;

    const bgByType = {
      available: 'transparent',
      reserved: 'rgba(250, 204, 21, 0.22)',
      maintenance: 'rgba(244, 63, 94, 0.18)',
      mine: 'rgba(34, 197, 94, 0.18)',
      blocked: 'rgba(148, 163, 184, 0.22)'
    };

    const activeBorder = 'rgba(35, 128, 72, 0.92)';

    return (
      <Box
        sx={{
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
          bgcolor: 'background.paper'
        }}
      >
        <Box sx={{ maxHeight: isFullscreen ? 'calc(100vh - 220px)' : '42vh', overflowY: 'auto' }}>
          {timelineHourGroups.groups.map((hourGroup) => (
            <Box
              key={hourGroup.hourKey}
              sx={{
                display: 'grid',
                gridTemplateColumns: '64px 1fr',
                gap: 1.25,
                px: 1.5,
                py: 1,
                borderBottom: '1px solid',
                borderColor: 'divider'
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: 800, color: 'text.secondary', pt: 0.5 }}>
                {hourGroup.hourLabel}
              </Typography>

              <Box
                sx={{
                  position: 'relative',
                  pl: 1.25,
                  borderLeft: '2px solid',
                  borderColor: 'rgba(148, 163, 184, 0.35)',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {hourGroup.slots.map((slot, idx) => {
                  const canUseAsStart = startOptionsSet.has(slot.slotTime);
                  const slotEndTime = slot.slotEnd ? slot.slotEnd.format('HH:mm') : '';
                  const canUseAsEnd = !!slotEndTime && endOptionsSet.has(slotEndTime);
                  const clickable =
                    isFullscreen &&
                    canSelectGraphically &&
                    (timelineSelectionStep === 'start' ? canUseAsStart : canUseAsEnd);

                  const isStartMarker = slot.slotTime === selectedStart;
                  const isEndMarker =
                    !!selectedEnd &&
                    !!slot.slotEnd &&
                    slot.slotEnd.format('HH:mm') === selectedEnd;
                  const isInsideSelection =
                    !!timeRanges.from?.value &&
                    !!timeRanges.to?.value &&
                    slot.slotStart.isAfter(timeRanges.from.value) &&
                    slot.slotStart.isBefore(timeRanges.to.value);

                  const dividerOpacity = idx === 0 ? 0 : 1;

                  return (
                    <Box
                      key={slot.key}
                      role={clickable ? 'button' : undefined}
                      data-testid={`availability-slot-${slot.slotTime.replace(':', '-')}`}
                      data-slot-type={slot.slotType}
                      data-slot-end={slotEndTime}
                      onClick={() => {
                        if (!clickable) {
                          return;
                        }

                        if (timelineSelectionStep === 'end' && slotEndTime) {
                          handleTimelineSlotClick(slotEndTime);
                          return;
                        }

                        handleTimelineSlotClick(slot.slotTime);
                      }}
                      sx={{
                        height: segmentHeight,
                        borderTop: dividerOpacity ? '1px solid rgba(148, 163, 184, 0.25)' : 'none',
                        cursor: clickable ? 'pointer' : 'default',
                        bgcolor: isInsideSelection ? 'rgba(35, 128, 72, 0.10)' : (bgByType[slot.slotType] || 'transparent'),
                        borderRadius: 1,
                        position: 'relative',
                        transition: 'background-color 120ms ease',
                        '&:hover': clickable ? { backgroundColor: 'rgba(2, 132, 199, 0.08)' } : undefined
                      }}
                    >
                      {(isStartMarker || isEndMarker) && (
                        <Box
                          sx={{
                            position: 'absolute',
                            inset: 0,
                            border: `2px solid ${activeBorder}`,
                            borderRadius: 1
                          }}
                        />
                      )}
                      {(isStartMarker || isEndMarker) && (
                        <Typography
                          variant="caption"
                          sx={{
                            position: 'absolute',
                            right: 6,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontWeight: 900,
                            fontSize: 10,
                            color: 'secondary.main'
                          }}
                        >
                          {isStartMarker ? 'I' : 'F'}
                        </Typography>
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
          ))}

          {timelineHourGroups.closingRow && (
            <Box
              sx={{
                px: 1.5,
                py: 1,
                display: 'grid',
                gridTemplateColumns: '64px 1fr',
                gap: 1.25,
                alignItems: 'center'
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: 800, color: 'text.secondary' }}>
                {timelineHourGroups.closingRow.slotTime}
              </Typography>
              <Box sx={{ height: 8, borderLeft: '2px solid rgba(148, 163, 184, 0.35)' }} />
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const ceil = (option, dayjsClass) => {
    dayjsClass.prototype.ceil = function (unit, amount) {
        return this.add(amount - (this.get(unit) % amount), unit).startOf(unit);
    };
  };
  dayjs.extend(ceil);
  dayjs.extend(isSameOrBefore);

  const fetchMonthlyReservations = (date, id) => {
    // Calculate first and last day of the month for the data fetch
    const firstDayOfMonth = date.startOf('month');
    const lastDayOfMonth = date.endOf('month');
    
    const fromDate = firstDayOfMonth.format('DDMMYY');
    const toDate = lastDayOfMonth.format('DDMMYY');
    
    apiClient.get(`amenity/reservations/${fromDate}/${toDate}/${id}`, {}, { action: 'fetch_amenity_reservations_range' })
      .then(response => {
        if (response.status === 200) {
          setMonthReservations(response.data.data);
        }
      })
      .catch(error => {
        console.error('Error fetching monthly reservations:', error);
      });
  };

  const fetchReservations = (date,id,timeRangesLocal = timeRanges,amenityLocal = amenity) => {
    const formated_date = date.format('DDMMYY');
    const dayOfWeek = date.day() || 7;
    apiClient.get(`amenity/reservations/${formated_date}/${id}`, {}, { action: 'fetch_amenity_reservations' })
      .then(response => {
        if (response.status === 200) {
          let franjas = null;
          if (amenityLocal.servicio.length > 0) {
            amenityLocal.servicio.forEach(servicio => {
              if (servicio.dias.includes(dayOfWeek)) {
                franjas = servicio.franjas;
                return;
              } else if (servicio.dias.includes(0)) {
                franjas = servicio.franjas;
              }
            });
          }
          let dataArray =[]
          if (franjas) {
            franjas.forEach(franja => {
              const inicio_str = franja.split('-')[0];
              const fin_str = franja.split('-')[1];
              const inicio = date.set('hour', parseInt(inicio_str.split(':')[0])).set('minute', parseInt(inicio_str.split(':')[1])).set('second', 0);
              const fin = date.set('hour', parseInt(fin_str.split(':')[0])).set('minute', parseInt(fin_str.split(':')[1])).set('second', 0);
              const franja_id = `${amenityId}-${inicio.unix()}`;
              response.data.data[franja_id] = {"servicio": true, "confirmada": true,"inicio": inicio.unix(),"fin": fin.unix(), "inicio_uf": inicio_str, "fin_uf": fin_str};
            });
            dataArray = Object.entries(response.data.data).map(([id, value]) => ({ id, ...value }));
            dataArray.sort((a, b) => a.id.localeCompare(b.id));
          } else {
            dataArray = Object.entries(response.data.data).map(([id, value]) => ({ id, ...value }));
          }
          setAmenityReservations(dataArray);
          setReservationsLoadedKey(formated_date);
        }
      })
      .catch(error => {
        console.error('Error fetching reservations:', error);
        setSnackbar({ open: true, message: 'Hubo un error obteniendo las reservaciones de la amenidad', severity: 'error' });
      });
  }

  const fetchInfo = (date,id) => {

    const dayOfWeek = date.day() || 7;
    apiClient.get(`amenity/${id}`, {}, { action: 'fetch_amenity' })
      .then(response => {
        if (response.status === 200) {
          let disponible_hoy = false;
          let amenidad_nocturna = false;
          let inicio = date;
          let inicio_uf = "00:00";
          let fin = date;
          let fin_uf = "23:59";
          let amenityTemp = response.data.data;
          amenityTemp.horario_predefinido = false;
          amenityTemp.dia_de_semana = weekDays[dayOfWeek-1]
          amenityTemp.mes = monthsSpa[date.month()];
          amenityTemp.showBlock = false;
          
          let timeRangesTemp = {"from": {"min":date,"max":date,"value":date}, "to": {"min":date,"max":date,"value": date}}
          let initialFrom = date;
          let initialTo = date;
          for (const horario of response.data.data.horarios) {
            if (horario.dias.includes(dayOfWeek)) {
              disponible_hoy = true;
              inicio_uf = horario.hora_inicio;
              fin_uf = horario.hora_fin;
              inicio = date.set('hour', parseInt(horario.hora_inicio.split(':')[0])).set('minute', parseInt(horario.hora_inicio.split(':')[1])).set('second', 0);
              fin = date.set('hour', parseInt(horario.hora_fin.split(':')[0])).set('minute', parseInt(horario.hora_fin.split(':')[1])).set('second', 0);
              const minDuration = amenityTemp.reservacion.tiempo_minimo;
              const defaultEnd = dayjs(inicio).add(minDuration * 2, 'minutes');
              initialFrom = inicio;
              initialTo = defaultEnd.isAfter(fin) ? fin : defaultEnd;
              timeRangesTemp = {
                "from": {
                  "min": inicio,
                  "max": fin.subtract(minDuration, "minutes"),
                  "value": initialFrom
                },
                "to": {
                  "min": inicio.add(minDuration, "minutes"),
                  "max": fin,
                  "value": initialTo
                }
              };
              if (horario.hora_inicio > horario.hora_fin) {
                amenidad_nocturna = true;
                timeRangesTemp.from.max = date.set('hour', 23).set('minute', 59).set('second', 59);
              }
              break;
            }
          }
          if (response.data.data.reservacion.horario_predefinido) {
            amenityTemp.horario_predefinido = true;
            let from_all = date.set('hour', parseInt(response.data.data.reservacion.horario_predefinido.hora_inicio.split(':')[0])).set('minute', parseInt(response.data.data.reservacion.horario_predefinido.hora_inicio.split(':')[1])).set('second', 0);
            let to_all = date.set('hour', parseInt(response.data.data.reservacion.horario_predefinido.hora_fin.split(':')[0])).set('minute', parseInt(response.data.data.reservacion.horario_predefinido.hora_fin.split(':')[1])).set('second', 0);
            timeRangesTemp = {"from": {"min":from_all,"max":from_all,"value": from_all}, "to": {"min":to_all,"max":to_all,"value":to_all}};
            initialFrom = from_all;
            initialTo = to_all;
          }
          amenityTemp.can_reserve = AuthService.userRoleIncludes(["habitante","admin"])
          if (disponible_hoy && amenityTemp.bloquear) {
            if (dayjs.unix(amenityTemp.bloquear.fecha_fin).isAfter(inicio)) {
              amenityTemp.showBlock = true;
            }
          }
          amenityTemp.amenidad_nocturna = amenidad_nocturna;
          setSelectionMode('free');
          setTimeSelectionError('');
          setTimelineSelectionStep('start');
          setTimelineFullscreen(false);
          setInitialTimeValues({ from: initialFrom, to: initialTo });
          setTimeRanges(timeRangesTemp);
          setAmenity({"disponible_hoy": disponible_hoy, "horario_hoy": {"inicio": inicio,"fin": fin, "inicio_uf":inicio_uf, "fin_uf": fin_uf},...response.data.data});
          fetchReservations(date,amenityId,timeRangesTemp,{"disponible_hoy": disponible_hoy, "horario_hoy": {"inicio": inicio,"fin": fin, "inicio_uf":inicio_uf, "fin_uf": fin_uf},...response.data.data});
          setShowBackdrop(false);
          setLoading(false);       
        }
      })
      .catch(error => {
        setRedirect({ trigger: true, route: '/amenidades' });
        console.error('Error fetching amenities:', error);
        setSnackbar({ open: true, message: 'Hubo un error obteniendo los detalles de la amenidad', severity: 'error' });
        setShowBackdrop(false);
      });
  }

  const reservationDrawer = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 2,
          bgcolor: 'primary.main',
          px: 2,
          pt: 5,
          pb: 1.5,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}
      >
        <IconButton
          onClick={handleDrawerToggle}
          sx={{
            width: 40,
            height: 40,
            ml: -1,
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.12)' }
          }}
        >
          <ArrowBackIcon sx={{ fontSize: 28 }} />
        </IconButton>
        <Typography sx={{ flex: 1, textAlign: 'center', color: 'primary.contrastText', fontWeight: 700, fontSize: 18, pr: '40px' }}>
          Reservar Amenidad
        </Typography>
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', px: 2.5, py: 3, pb: 18 }}>
        {amenity.reservacion && (
          <>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"es"}>
              <DatePicker
                sx={{ mt: 1, mb: 2, width: '100%' }}
                value={date}
                label="Dia"
                onChange={handleDateChange}
                onMonthChange={handleMonthChange}
                disablePast={true}
                maxDate={dayjs().add(amenity.reservacion.max_dias_previos, 'day')}
                dayOfWeekFormatter={(day) => day.charAt(0).toUpperCase() + day.slice(1)}
                slots={{
                  day: (props) => {
                    const dateStr = dayjs(props.day).format('DDMMYY');
                    const hasDot = monthReservations[dateStr] && Object.keys(monthReservations[dateStr]).length > 0;
                    return (
                      <div
                        style={{
                          position: 'relative',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <PickersDay {...props} />
                        {hasDot && (
                          <div
                            style={{
                              position: 'absolute',
                              bottom: '2px',
                              width: '6px',
                              height: '6px',
                              borderRadius: '50%',
                              backgroundColor: '#ff9800'
                            }}
                          />
                        )}
                      </div>
                    );
                  }
                }}
              />
              {amenity.horario_predefinido && (
                <Typography variant="body2" color="textSecondary" sx={{ my: 1 }}>
                  Este horario esta predefinido por administracion y no puede ser modificado.
                </Typography>
              )}
              <FormControl fullWidth sx={{ my: 1 }}>
                <InputLabel id="time-start-label">Desde</InputLabel>
                <Select
                  labelId="time-start-label"
                  id="time-start"
                  value={safeStartValue}
                  label="Desde"
                  onChange={handleTimeStartChange}
                  disabled={!amenity.disponible_hoy || amenity.horario_predefinido}
                >
                  {startOptionsForSelect
                    .map((time) => (
                      <MenuItem key={time} value={time}>
                        {time}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ my: 1 }}>
                <InputLabel id="time-end-label">Hasta</InputLabel>
                <Select
                  labelId="time-end-label"
                  id="time-end"
                  value={safeEndValue}
                  label="Hasta"
                  onChange={handleTimeEndChange}
                  disabled={!amenity.disponible_hoy || amenity.horario_predefinido}
                >
                  {endOptionsForSelect
                    .map((time) => (
                      <MenuItem key={time} value={time}>
                        {time}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              {!amenity.amenidad_nocturna && timeSelectionError && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                  {timeSelectionError}
                </Typography>
              )}
            </LocalizationProvider>

            {!amenity.horario_predefinido && (
              <Typography variant="caption" color="textSecondary" component="div" sx={{ mt: 1 }}>
                Tiempo maximo de reserva es de {timeToString(amenity.reservacion.tiempo_maximo)} *
              </Typography>
            )}
            {amenity.amenidad_nocturna && (
              <Typography variant="body2" color="textSecondary" sx={{ mt: 1, fontStyle: 'italic' }}>
                * Esta es una reservación nocturna que termina al día siguiente.
              </Typography>
            )}

            <Divider sx={{ my: 3 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1.5 }}>
              <Typography variant="h6" component="div" sx={{ mt: 0, fontWeight: 800, color: 'text.primary' }}>
                Disponibilidad del Día
              </Typography>
              {!amenity.amenidad_nocturna && !amenity.horario_predefinido && amenity.disponible_hoy && (
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<OpenInFullIcon />}
                  onClick={() => setTimelineFullscreen(true)}
                  sx={{ fontWeight: 800, textTransform: 'none' }}
                >
                  Pantalla completa
                </Button>
              )}
            </Box>

            {amenity.disponible_hoy ? (
              <>
                {!amenity.amenidad_nocturna && !amenity.horario_predefinido && (
                  <Typography variant="caption" color="text.secondary" sx={{ mb: 1.2, display: 'block' }}>
                    {timelineSelectionStep === 'start'
                      ? 'Selecciona una hora de inicio (libre, sin traslape con bloques o reservas).'
                      : 'Ahora selecciona una hora de finalización válida para completar el rango.'}
                  </Typography>
                )}
                {renderAvailabilityGrid(false)}
              </>
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                La amenidad no esta disponible en la fecha seleccionada
              </Typography>
            )}

            {amenity.conflicto && (
              <Typography variant="body2" color="error" sx={{ mt: 2, fontWeight: 700 }}>
                El rango de tiempo selecionado tiene conflicto con otra reservacion.
              </Typography>
            )}

            <Dialog
              fullScreen
              open={timelineFullscreen}
              onClose={() => setTimelineFullscreen(false)}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 5, pb: 1.5, bgcolor: 'primary.main' }}>
                <Typography sx={{ color: 'primary.contrastText', fontWeight: 800, fontSize: 18 }}>
                  Selección gráfica
                </Typography>
                <IconButton
                  onClick={() => setTimelineFullscreen(false)}
                  sx={{ color: 'primary.contrastText' }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>

              <Box sx={{ px: 2.5, py: 2, pb: 3, bgcolor: 'background.default', minHeight: '100%' }}>
                <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5 }}>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: 999,
                      bgcolor: 'background.paper',
                      overflow: 'hidden'
                    }}
                  >
                    <Button
                      onClick={() => setTimelineSelectionStep('start')}
                      color="inherit"
                      sx={{
                        minWidth: 0,
                        px: 1.5,
                        py: 0.75,
                        borderRadius: 0,
                        textTransform: 'none',
                        fontWeight: 900,
                        color: timelineSelectionStep === 'start' ? 'secondary.main' : 'text.secondary',
                        bgcolor: timelineSelectionStep === 'start' ? 'rgba(35, 128, 72, 0.10)' : 'transparent'
                      }}
                    >
                      Inicio
                    </Button>

                    <Box sx={{ px: 0.75, display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                      <SyncAltIcon fontSize="small" />
                    </Box>

                    <Button
                      onClick={() => setTimelineSelectionStep('end')}
                      color="inherit"
                      sx={{
                        minWidth: 0,
                        px: 1.5,
                        py: 0.75,
                        borderRadius: 0,
                        textTransform: 'none',
                        fontWeight: 900,
                        color: timelineSelectionStep === 'end' ? 'secondary.main' : 'text.secondary',
                        bgcolor: timelineSelectionStep === 'end' ? 'rgba(35, 128, 72, 0.10)' : 'transparent'
                      }}
                    >
                      Fin
                    </Button>
                  </Box>

                  <Typography variant="body2" sx={{ fontWeight: 900, color: 'text.secondary', whiteSpace: 'nowrap' }}>
                    {selectedStartValue && selectedEndValue ? `${selectedStartValue}–${selectedEndValue}` : ''}
                  </Typography>
                </Box>

                {renderAvailabilityGrid(true)}

                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  sx={{ mt: 2, fontWeight: 800 }}
                  onClick={() => setTimelineFullscreen(false)}
                >
                  Confirmar selección
                </Button>
              </Box>
            </Dialog>
          </>
        )}
      </Box>

      <Box
        sx={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'background.default',
          boxShadow: '0 -4px 10px rgba(0,0,0,0.06)',
          px: 2.5,
          pt: 2,
          pb: 3
        }}
      >
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          size="large"
          onClick={() => (AuthService.getCurrentUserRole() === 'admin' ? handleAdminReservation() : makeReservationPre())}
          disabled={amenity.conflicto || hasNoValidTimeOptions}
          sx={{
            py: 1.8,
            fontWeight: 900,
            letterSpacing: 1,
            textTransform: 'uppercase',
            borderRadius: '10px'
          }}
        >
          Reservar
        </Button>
        <Button
          fullWidth
          color="inherit"
          onClick={handleDrawerToggle}
          sx={{ mt: 1, fontWeight: 800, letterSpacing: 1, textTransform: 'uppercase', opacity: 0.65 }}
        >
          Cancelar
        </Button>
      </Box>
    </Box>
  );
  const generateTimeString = (horario) => {
    let timeString = '';

    // Function to group consecutive days
    const groupConsecutiveDays = (days) => {
      const groups = [];
      let currentGroup = [days[0]];
      days.sort((a, b) => a - b);
      for (let i = 1; i < days.length; i++) {
        if (days[i] - days[i-1] === 1) {
          currentGroup.push(days[i]);
        } else {
          groups.push(currentGroup);
          currentGroup = [days[i]];
        }
      }
      groups.push(currentGroup);
      return groups;
    };

    // Generate day range string
    const getDayRangeString = (group) => {
      if (group.length === 1) {
        return weekDays[group[0] - 1];
      } else if (group.length === 2) {
        return `${weekDays[group[0] - 1]} y ${weekDays[group[1] - 1]}`;
      } else {
        return `${weekDays[group[0] - 1]} a ${weekDays[group[group.length - 1] - 1]}`;
      }
    };

    if (horario.dias.length === 7) {
      timeString += 'Lunes a Domingo';
    } else {
      const groupedDays = groupConsecutiveDays(horario.dias);
      timeString += groupedDays.map(getDayRangeString).join(', ');
    }

    // Add time ranges
    if (horario.franjas && horario.franjas.length > 0) {
      timeString += ' de ';
      timeString += horario.franjas.join(' y ');
    }
    timeString += ` de ${horario.hora_inicio} a ${horario.hora_fin}`;
    return timeString.trim();
  };

  const handleAdminOptionsDrawerToggle = () => {
    setAdminOptionsDrawerOpen(!adminOptionsDrawerOpen);
  };

  const renderDotList = (items, keyPrefix) => (
    <Box component="ul" sx={{ m: 0, mt: 1, p: 0, listStyle: 'none' }}>
      {items.map((item, idx) => (
        <Box
          component="li"
          key={`${keyPrefix}-${idx}`}
          sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 0.5 }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor: 'text.primary',
              mt: '0.55rem',
              flexShrink: 0
            }}
          />
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            {item}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  const handleBlockAmenity = () => {
    setBlockModalOpen(true);
    setAdminOptionsDrawerOpen(false);
  };

  const handleBlockInputChange = (event) => {
    const { name, value } = event.target;
    setBlockData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleBlockSubmit = () => {
    setShowBackdrop(true);
    let ts = Math.floor(new Date().getTime() / 1000);
    if (new Date(blockData.fecha_fin).getTime() / 1000 < ts) {
      setSnackbar({ open: true, message: 'No es posible bloquear una fecha pasada', severity: 'error' });
      setShowBackdrop(false);
      return;
    }
    if (blockData.fecha_inicio > blockData.fecha_fin) {
      setSnackbar({ open: true, message: 'La fecha de inicio no puede ser mayor a la fecha de fin', severity: 'error' });
      setShowBackdrop(false);
      return;
    }
    apiClient.post(`amenity/${amenityId}/block`, {
        motivo: blockData.motivo,
        fecha_inicio: blockData.fecha_inicio ? new Date(blockData.fecha_inicio).getTime() / 1000 : null,
        fecha_fin: blockData.fecha_fin ? new Date(blockData.fecha_fin).getTime() / 1000 : null
    }, {}, { action: 'block_amenity' })
      .then(response => {
        if (response.status === 200) {
          setSnackbar({ open: true, message: 'Amenidad bloqueada correctamente', severity: 'success' });
          fetchInfo(date, amenityId);
          setBlockModalOpen(false);
        }
      })
      .catch(error => {
        console.error('Error blocking amenity:', error);
        setSnackbar({ open: true, message: 'Error al bloquear la amenidad', severity: 'error' });
      })
      .finally(() => {
        setShowBackdrop(false);
      });
  };

  const adminOptionsDrawer = (
    <Card
    sx={{ py: 3, px: 2, display: 'block', marginLeft: 'auto', marginRight: 'auto', borderTopLeftRadius: "20px", borderTopRightRadius: "20px", borderBottomRightRadius: "0px", borderBottomLeftRadius: "0px", maxWidth: "550px", width: "100%" }}>
      <CardContent>
        <Typography variant="h6" component="div" gutterBottom>
          Opciones de Administrador
        </Typography>
        <List>
          <ListItem 
            button 
            onClick={() => {
              setAdminOptionsDrawerOpen(false);
              handleDrawerToggle();
            }}
            disabled={amenity.reservacion && !amenity.reservacion.necesaria}
          >
            <ListItemIcon>
              <PersonAddIcon />
            </ListItemIcon>
            <ListItemText primary="Reservar para un residente" secondary={amenity.reservacion && !amenity.reservacion.necesaria && "Esta amenidad no requiere reservaciones"} />
          </ListItem>
          <ListItem button onClick={() => {
            setAdminOptionsDrawerOpen(false);
            setRedirect({ trigger: true, route: `/amenityadmin?id=${amenityId}` });
          }}>
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
            <ListItemText primary="Modificar esta amenidad" />
          </ListItem>
          <ListItem button disabled={amenity.reservacion && !amenity.reservacion.necesaria} onClick={handleBlockAmenity}>
            <ListItemIcon>
              <BlockIcon />
            </ListItemIcon>
            <ListItemText primary="Bloquear esta amenidad" secondary={amenity.reservacion && !amenity.reservacion.necesaria && "Esta amenidad no requiere reservaciones"} />
          </ListItem>
          <ListItem button onClick={() => {
            setAdminOptionsDrawerOpen(false);
            setRedirect({ trigger: true, route: '/amenityadmin' });
          }}>
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText primary="Administrar todas las amenidades" />
          </ListItem>
        </List>
      </CardContent>
      <CardActions>
        <Button size="medium" onClick={handleAdminOptionsDrawerToggle} color="inherit" variant="outlined">Cerrar</Button>
      </CardActions>
    </Card>
  );

  React.useEffect(() => {
    if (amenityId === null) {
      setRedirect({ trigger: true, route: '/amenidades' });
    }
    if (AuthService.shouldLimitAutomatedAgentRequests()) {
      setLoading(false);
      setShowBackdrop(false);
      return;
    }
    setShowBackdrop(true);
    setLoading(true);
    setNavbarState({ ...navbarState, showBack: true, showOptions: false, showSearch: false})
    fetchInfo(date,amenityId);
    // Fetch the monthly reservations for the dots in the calendar
    fetchMonthlyReservations(date, amenityId);
  }, [date,refresh]);

const container = window !== undefined ? () => window().document.body : undefined;
return (
    <>
    <Container maxWidth="sm" disableGutters>
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
    <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CustomSnackbar
        open={snackbar.open}
        onClose={handleSnackbarClose}
        message={snackbar.message}
        severity={snackbar.severity}
      />
      <Box sx={{ mt: 0, pb: 10 }}>
        {!loading && (
          <>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: 256,
                overflow: 'hidden',
                borderBottomLeftRadius: '24px',
                borderBottomRightRadius: '24px',
                boxShadow: '0 8px 20px rgba(0,0,0,0.08)'
              }}
            >
              <Box
                component="img"
                src={`${apiUrl}/img/amenities/${amenityId}.jpg`}
                alt="Amenity Image"
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to top, rgba(0,0,0,0.10), rgba(0,0,0,0))',
                  pointerEvents: 'none'
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  px: 2,
                  pt: { xs: 2, sm: 2.5 },
                  pb: 1.5,
                  background: 'linear-gradient(to bottom, rgba(0,0,0,0.55), rgba(0,0,0,0))'
                }}
              >
                <IconButton
                  onClick={() => setRedirect({ trigger: true, route: '/amenidades' })}
                  sx={{
                    width: 40,
                    height: 40,
                    ml: -1,
                    color: 'white',
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.12)' },
                  }}
                >
                  <ArrowBackIcon sx={{ fontSize: 28 }} />
                </IconButton>
              </Box>
            </Box>

            <Box sx={{ px: 3, pt: 3, pb: 4 }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2, color: 'text.primary' }}>
                  {amenity.nombre}
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, color: 'text.secondary' }}>
                  {amenity.descripcion}
                </Typography>
                {amenity.cantidad > 1 && (
                  <Typography variant="body2" sx={{ mt: 1, fontWeight: 600, color: 'text.secondary' }}>
                    {amenity.cantidad} unidades disponibles
                  </Typography>
                )}
              </Box>

                {amenity.showBlock && (
                  <Alert
                    severity="warning"
                    icon={<WarningIcon />}
                    sx={{
                      mt: 2,
                      mb: 3,
                      '& .MuiAlert-icon': {
                        alignItems: 'center'
                      }
                    }}
                  >
                    Esta amenidad esta bloqueada del {dayjs.unix(amenity.bloquear.fecha_inicio).format("DD/MM/YY HH:mm")} al {dayjs.unix(amenity.bloquear.fecha_fin).format("DD/MM/YY HH:mm")} por {amenity.bloquear.motivo}
                  </Alert>
                )}

                <Box sx={{ mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary' }}>
                    Horarios
                  </Typography>
                  {renderDotList(
                    amenity.horarios.map((horario) => generateTimeString(horario)),
                    'horario'
                  )}
                </Box>

                {amenity.obs.length > 0 && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary' }}>
                      Reglas y Observaciones
                    </Typography>
                    {renderDotList(amenity.obs, 'obs')}
                  </Box>
                )}

                <Box sx={{ mb: 2 }}>
                  {amenity.reservacion.necesaria ? (
                    <>
                      <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary' }}>
                        Reservación
                      </Typography>
                      {renderDotList(
                        [
                          ...(amenity.amenidad_nocturna ? ['Esta amenidad es de uso nocturno.'] : []),
                          ...(!amenity.horario_predefinido
                            ? [`Tiempo maximo de reservacion ${timeToString(amenity.reservacion.tiempo_maximo)}.`]
                            : []),
                          ...(amenity.reservacion.monto_pago > 0
                            ? [`Requiere pago de Q.${amenity.reservacion.monto_pago.toFixed(2)}`]
                            : [])
                        ],
                        'reservacion'
                      )}
                    </>
                  ) : (
                    <>
                      <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary' }}>
                        Uso Libre
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                        Esta amenidad es de uso libre. No requiere reservación.
                      </Typography>
                    </>
                  )}
                </Box>

                {!loading && amenity.can_reserve && amenity.reservacion.necesaria && (
                  <Box sx={{ pt: 1.5 }}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="secondary"
                      size="large"
                      startIcon={AuthService.userRoleIncludes(["admin", "superuser"]) ? <MoreVertIcon /> : <EventAvailableIcon />}
                      onClick={AuthService.userRoleIncludes(["admin", "superuser"]) ? handleAdminOptionsDrawerToggle : handleDrawerToggle}
                      disabled={amenity.conflicto}
                      sx={{
                        py: 1.7,
                        fontWeight: 800,
                        letterSpacing: 1,
                        textTransform: 'uppercase',
                        borderRadius: '10px'
                      }}
                    >
                      {AuthService.userRoleIncludes(["admin", "superuser"]) ? 'Opciones' : 'Reservar'}
                    </Button>
                  </Box>
                )}

              {!loading && !amenity.reservacion.necesaria && AuthService.userRoleIncludes(["admin", "superuser"]) && (
                <Box sx={{ pt: 1.5 }}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    size="large"
                    startIcon={<MoreHorizIcon />}
                    onClick={handleAdminOptionsDrawerToggle}
                    sx={{
                      py: 1.7,
                      fontWeight: 800,
                      letterSpacing: 1,
                      textTransform: 'uppercase',
                      borderRadius: '10px'
                    }}
                  >
                    Mas Opciones
                  </Button>
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>
    {!loading && (
    <>
    <Drawer
          container={container}
          anchor="bottom"
          variant="temporary"
          open={drawerShow}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          PaperProps={{ elevation: 0, style: { height: '100%', maxHeight: '100%' } }}
          sx={{
            display: { xs: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '440' },
          }}
        >
          {reservationDrawer}
    </Drawer>
    {!loading && (
    <Drawer
          container={container}
          anchor="bottom"
          variant="temporary"
          open={adminOptionsDrawerOpen}
          onClose={handleAdminOptionsDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{ elevation: 0, style: { backgroundColor: "transparent" } }}
          sx={{
            display: { xs: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '440' },
          }}
        >
          {adminOptionsDrawer}
    </Drawer>
    )}
    <Dialog open={blockModalOpen} onClose={() => setBlockModalOpen(false)}>
        <DialogTitle>Bloquear {amenity.nombre}</DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="text.secondary">Durante el periodo seleccionado, la amenidad no estará disponible para los usuarios.</Typography>
          <TextField
            fullWidth
            label="Motivo"
            name="motivo"
            value={blockData.motivo}
            onChange={handleBlockInputChange}
            placeholder="Describe brevemente el motivo por el cual no se podria utilizar la amenidad"
            margin="normal"
            multiline
          />
          <TextField
            fullWidth
            label="Fecha de inicio"
            name="fecha_inicio"
            type="datetime-local"
            value={blockData.fecha_inicio}
            onChange={handleBlockInputChange}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: new Date().toISOString().slice(0, 16)
            }}
          />
          <TextField
            fullWidth
            label="Fecha de fin"
            name="fecha_fin"
            type="datetime-local"
            value={blockData.fecha_fin}
            onChange={handleBlockInputChange}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: new Date(blockData.fecha_inicio).toISOString().slice(0, 16)
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBlockModalOpen(false)}>Cancelar</Button>
          <Button onClick={handleBlockSubmit} color="secondary">Bloquear</Button>
        </DialogActions>
    </Dialog>
    <Dialog open={adminReservationDialog.show} onClose={closeAdminReservationDialog}>
        <DialogTitle>Datos de Residente</DialogTitle>
        <DialogContent>
          <TextField
            label="Nombre de Residente"
            value={adminReservationDialog.resident_name}
            onChange={(e) => setAdminReservationDialog({ ...adminReservationDialog, resident_name: e.target.value })}
            sx={{mb: 2, mt: 2}}
            fullWidth
          />
          <TextField
            label={AppConfig.getLocal('unit_type')}
            value={adminReservationDialog.resident_unit}
            placeholder={unit_sample}
            onChange={(e) => handleUnitChange(e)}
            fullWidth
            error={adminReservationDialog.error}
            helperText={adminReservationDialog.error_msg}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAdminReservationDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => makeReservationPre()} color="secondary" variant="contained">
            Continuar
          </Button>
        </DialogActions>
    </Dialog>
    <Dialog open={reservationDialog} onClose={closeReservationDialog}>
        <DialogTitle>Confirmar Reserva</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {reservationDialog ? <Typography>¿Está seguro que desea reservar esta amenidad el dia {amenity.dia_de_semana}, {date.format('DD')} de {amenity.mes} de {timeRanges.from.value.format('HH:mm')} a {timeRanges.to.value.format('HH:mm')} ?</Typography> : ''}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeReservationDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => makeReservation()} color="secondary" variant="contained">
            Confirmar
          </Button>
        </DialogActions>
    </Dialog>
    </>
    )}
      
    </Container>
  </>);
}